import Slider from "../../../../components/ui/Slider";
import { Category, Product } from "../../types";
import Heading from "../Heading";
import arrowLeft from "../../assets/images/arrow-left.png";
import arrowRight from "../../assets/images/arrow-right.png";
import ProductCard from "./ProductCard";
import { useCart } from "../../hooks/use-cart";

interface Props {
  className?: string;
  selectedCategory: Category | null;
  products: Product[];
  onProductClick?: (product: Product) => void;
  noProductsText?: string;
}

const ProductList = ({
  className = "",
  products,
  selectedCategory,
  noProductsText = "This category doesn't have any product",
}: Props) => {
  const { isProductInCart } = useCart();
  return (
    <div className={`flex flex-col justify-end ${className}`}>
      {/** Category */}

      {selectedCategory && (
        <Heading
          className="mb-[-40px] ml-2"
          titleWords={[
            {
              content: selectedCategory?.name,
              colorGradient:
                "linear-gradient(to right, rgba(56, 234, 245, 0.5), rgba(56, 234, 245, 1), rgba(56, 234, 245, 0.5))",
            },
          ]}
          textClassName="!text-[34px]"
        />
      )}

      {/** Products List (With slider) */}
      <Slider
        includeControls
        arrowLeftImage={arrowLeft}
        arrowRightImage={arrowRight}
      >
        {products?.length ? (
          <div className="flex items-center space-x-5">
            {products?.map((product) => (
              <ProductCard
                product={product}
                currency="USD"
                key={product.id}
                highlighted={isProductInCart(product.id)}
              />
            ))}
          </div>
        ) : (
          <p className="text-xl text-red-500">{noProductsText}</p>
        )}
      </Slider>
    </div>
  );
};

export default ProductList;
